import script from "./LandingPageNW.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageNW.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageNW.vue?vue&type=style&index=0&id=cea52b94&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cea52b94"]])

export default __exports__